<button
  [disabled]="disabled"
  [type]="type"
  class="generic"
  [class]="variant"
  (click)="handleClick()"
>
  {{ label }}
  @if (icon){
  <span
    class="icon"
    [style]="{ mask: `url('${icon}') no-repeat center`}"
  ></span>
  }
</button>
